import type { PatentData } from '@/services/patent-service.interface';
import { computed, type Ref } from 'vue';
import { useI18n } from '@/composables/useI18n';
import _ from 'lodash';

/**
 * 原文语言选项
 */
export interface OriginOption {
    lang: string;
    type: string;
}

export function useOriginOptions(patent: Ref<Partial<PatentData>>) {
    const { t } = useI18n();
    
    const originOptions = computed<OriginOption[]>(() => {
        const noTrans = [t('Not displayed'), 'CN', 'EN', 'JP'];
        let langs = _.uniq(patent.value.LANGS || []);
        langs = _.filter(langs, lang => !_.includes(noTrans, lang));

        const result = _.map(langs, lang => {
            return {
                lang,
                type: lang,
            };
        });

        return result;
    });

    return {
        originOptions,
    };
}